import { Grid, Paper, Typography } from "@material-ui/core";
import clsx from "clsx";
import EventDecision from "components/EventDecision/EventDecision";
import { observer } from "mobx-react";
import { EventStatus } from "models/thorEventModels/EventDetails";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { eventAnalysisStyles } from "./EventAnalysisStyles";

export default observer(function EventAnalysis() {
    const classes = eventAnalysisStyles();
    const { thorEventViewStore } = useStore();

    return (
        <div className={classes.container}>
            <Typography className={classes.mainTitle}>Event Conclusion</Typography>
            {thorEventViewStore.eventDetails.eventStatusId === EventStatus.Closed ? null : (
                <Typography className={classes.subTitle}>
                    After making a decision for each batch, you can choose an action
                    <br />
                    to take for the impacted batches based on the context above
                </Typography>
            )}

            <Paper className={classes.main} elevation={0}>
                <Grid container justifyContent="space-between">
                    {thorEventViewStore.eventSummary.batchSummaries
                        .filter((x) => x.isApproved !== null)
                        .map((x, index) => (
                            <Grid
                                item
                                xs={6}
                                key={x.batchId}
                                className={clsx(classes.batchInfo, {
                                    [classes.margin]: index === thorEventViewStore.eventSummary.batchSummaries.length,
                                })}
                            >
                                <Typography className={classes.title + " " + classes.batchTitle}>
                                    Batch #{x.batchNumber} -{" "}
                                    {x.isApproved === null
                                        ? "Pending"
                                        : x.isApproved === true
                                        ? "Excursion is supported"
                                        : "Excursion is not supported"}
                                </Typography>
                                {x.message.split("\n").map((message, index) => (
                                    <div className={classes.batchInfo} key={message}>
                                        {index + 1 === x.message.split("\n").length && <br />}
                                        <Typography
                                            className={clsx(classes.text, {
                                                [classes.messageText]: index + 1 === x.message.split("\n").length,
                                            })}
                                        >
                                            {message}
                                        </Typography>
                                    </div>
                                ))}
                            </Grid>
                        ))}
                </Grid>
                <EventDecision />
            </Paper>
        </div>
    );
});
